export default "__VITE_ASSET__fjMcqOKX__"